import { defineMessage } from '../../services/localization';

export const messages = {
    leastCharacters: defineMessage('use_or_more_characters'),
    containsNumber: defineMessage('use_a_number_eg'),
    containsUpperLowerCase: defineMessage('upper_and_lower_case_letters_eg_aa'),
    containsSpecialCharacter: defineMessage('use_a_symbol_eg'),
    invalidPassword: defineMessage('password_does_not_meet_criteria'),
};
